import * as yaml from "js-yaml";
import { isValidStudyName, STUDY_NAME_ERROR } from "shared/validation/studyName";

// YAMLをパースして設定を取得する（失敗時はnull）
const parseYamlConfig = (yamlConfig: string): any | null => {
  try {
    return yaml.load(yamlConfig);
  } catch (error) {
    alert("YAMLのパースに失敗しました。" + error);
    return null;
  }
};

// CFD実行に必要な最低条件を確認
export const canStartCfd = (yamlConfig: string): boolean => {
  const config = parseYamlConfig(yamlConfig);
  if (!config) return false;

  if (config?.application.study_name === "") {
    alert("study nameを入力して下さい。");
    return false;
  }
  if (!isValidStudyName(config?.application.study_name)) {
    alert(STUDY_NAME_ERROR);
    return false;
  }
  if (config?.application.base_stl === "") {
    alert("モーフィングする車体モデルを選択し、描画して下さい。");
    return false;
  }
  return true;
};

// ジオメトリチェックに必要な最低条件を確認
export const canStartGeometryCheck = (yamlConfig: string): boolean => {
  const config = parseYamlConfig(yamlConfig);
  if (!config) return false;

  if (config.application.base_stl === "" && config.application.cocoon_stl === "") {
    alert("チェックする車体モデルまたはコクーンを選択し、描画して下さい。");
    return false;
  }
  return true;
};
